import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { CookieConsentVersion } from 'constants/consent';
import { checkConsentGroup } from 'libs/utils/consentGroups';
import * as consentSelectors from 'state/consent/selectors';

const useIsConsentGroupEnabled = function useIsConsentGroupEnabled(group) {
  let readAfterBannerIsLoaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const cookieConsentVersion = useSelector(consentSelectors.getCookieConsentVersion);
  const {
    0: isConsentGroupEnabled,
    1: setIsConsentGroupEnabled
  } = useState(readAfterBannerIsLoaded ? false : checkConsentGroup(group));
  const handleBannerLoaded = useCallback(() => {
    setIsConsentGroupEnabled(checkConsentGroup(group));
  }, [group]);
  useEffect(() => {
    window.addEventListener('bannerLoaded', handleBannerLoaded);
    return () => {
      window.removeEventListener('bannerLoaded', handleBannerLoaded);
    };
  }, [handleBannerLoaded]);
  return useMemo(() => {
    if (cookieConsentVersion === CookieConsentVersion.None) return true;
    return isConsentGroupEnabled;
  }, [isConsentGroupEnabled, cookieConsentVersion]);
};

export default useIsConsentGroupEnabled;